import { RequireCapability } from '../../auth/RequireAuth';
import type { FeatureRoute } from '../types';
import { AdminsPage } from './AdminsPage';

/** Screens of this feature (A3). */
export const routes: FeatureRoute[] = [
  {
    path: 'admins',
    element: (
      <RequireCapability anyOf={['admins.manage']} what="admin accounts">
        <AdminsPage />
      </RequireCapability>
    ),
  },
];
